/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path, Line } from 'react-native-svg';

import { IconProps } from '../lib';

function Tree(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M132.476,181.2265a63.99546,63.99546,0,1,0,62.27163-111.367A7.98712,7.98712,0,0,1,190.7243,65.693a68.02876,68.02876,0,0,0-125.44861,0,7.98711,7.98711,0,0,1-4.02328,4.16655,63.99621,63.99621,0,1,0,62.27159,111.367A8.03193,8.03193,0,0,1,132.476,181.2265Z"
        opacity={0.2}
      />
      <Line
        x1={128}
        y1={232}
        x2={128}
        y2={88}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={128}
        y1={152}
        x2={80}
        y2={128}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={128}
        y1={128}
        x2={176}
        y2={104}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M132.476,181.2265a63.99546,63.99546,0,1,0,62.27163-111.367A7.98712,7.98712,0,0,1,190.7243,65.693a68.02876,68.02876,0,0,0-125.44861,0,7.98711,7.98711,0,0,1-4.02328,4.16655,63.99621,63.99621,0,1,0,62.27159,111.367A8.03193,8.03193,0,0,1,132.476,181.2265Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
    </Svg>
  );
}

export default Tree;
